import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { patchMessageSettings } from 'redux/anonymous-messages/actions';
import { Checkbox } from 'semantic-ui-react';

import CommonTextInput from
  'components/elements/inputs/CommonTextInput';

import './DirectMesssageAppearence.css';

const DirectMesssageAppearence = ({ id, me, patchMessageSettings, patchAnonymousMessageError }) => {
  const { t } = useTranslation();
  const defaultButtonText = t("Leave your message here...");
  const defaultSuccessText = t("Your message was sent successfully!");
  const defautNameFieldText = t("Your Name");
  const defaultEmailFieldText = t("Your Email Address");

  const checkboxChange = useCallback((_e, { name, checked }) => {
    const form = new FormData();
    form.append(`${name}`, checked);

    if (name === 'name_is_active') {
      if (checked) {
        form.append('name_is_required', true);
      } else {
        form.append('name_is_required', false);
      }
    }
    if (name === 'email_is_active') {
      if (checked) {
        form.append('email_is_required', true);
      } else {
        form.append('email_is_required', false);
      }
    }
    patchMessageSettings(id, form);
  }, []);

  const changeInputValue = (name, value) => {
    const form = new FormData();
    if (name === 'button_text' && value.trim() === '') {
      form.append(`${name}`, defaultButtonText);
    } else if (name === 'success_text' && value.trim() === '') {
      form.append(`${name}`, defaultSuccessText);
    } else if (name === 'name_text' && value.trim() === '') {
      form.append(`${name}`, defautNameFieldText);
    } else if (name === 'email_text' && value.trim() === '') {
      form.append(`${name}`, defaultEmailFieldText);
    } else {
      form.append(`${name}`, value);
    }
    patchMessageSettings(id, form);
  };

  const linkTextValidation = value => {
    const errors = [];
    if (value && value.length > 128) {
      errors.push(t("Ensure this field has no more than 128 characters"));
    }
    return errors;
  };

  return (
    <div className="direct-message-appearence__component">

      <h4>{t("Appearance")}</h4>

      <div className="direct-message-input-fieds-wrapper">
        <div className="direct-message-input-fieds-content">
          <CommonTextInput
            key={`direct_message_button_text_input_fied_key_${me && me.message_settings && me.message_settings.id}`}
            label={t("Message Text")}
            placeholder={defaultButtonText}
            initValue={me && me.message_settings && me.message_settings.button_text || defaultButtonText}
            executedFunction={value => { changeInputValue('button_text', value); }}
            validationErrors={value => { return linkTextValidation(value); }}
            actionErrors={patchAnonymousMessageError && patchAnonymousMessageError.button_text}
          />

          <CommonTextInput
            key={`direct_message_success_text_input_fied_key_${me && me.message_settings && me.message_settings.id}`}
            label={t("Success Message Text")}
            placeholder={defaultSuccessText}
            initValue={me && me.message_settings && me.message_settings.success_text || defaultSuccessText}
            executedFunction={value => { changeInputValue('success_text', value); }}
            validationErrors={value => { return linkTextValidation(value); }}
            actionErrors={patchAnonymousMessageError && patchAnonymousMessageError.success_text}
          />
        </div>
      </div>

      <div className="direct-message-settings-wrapper">
        <div className="header-section">
          <span>{t("Input Field Text")}</span>
          <span>{t("Required Field")}</span>
        </div>

        <div className="direct-message-settings-content">
          <div className="row">
            <div className="cell">
              <Checkbox
                name="name_is_active"
                checked={me.message_settings.name_is_active}
                onChange={checkboxChange}
              />
            </div>
            <div className="cell name">
              <CommonTextInput
                key={`direct_message_name_text_input_fied_key_${me && me.message_settings && me.message_settings.id}`}
                // label="Your Name Text"
                placeholder={defautNameFieldText}
                initValue={me && me.message_settings && me.message_settings.name_text || defautNameFieldText}
                executedFunction={value => { changeInputValue('name_text', value); }}
                validationErrors={value => { return linkTextValidation(value); }}
                actionErrors={patchAnonymousMessageError && patchAnonymousMessageError.name_text}
              />
            </div>
            <div className="cell">
              <Checkbox
                toggle
                name="name_is_required"
                checked={me.message_settings.name_is_required}
                onChange={checkboxChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="cell">
              <Checkbox
                name="email_is_active"
                checked={me.message_settings.email_is_active}
                onChange={checkboxChange}
              />
            </div>
            <div className="cell name">
              <CommonTextInput
                key={`direct_message_email_text_input_fied_key_${me && me.message_settings && me.message_settings.id}`}
                // label="Your Email Text"
                placeholder={defaultEmailFieldText}
                initValue={me && me.message_settings && me.message_settings.email_text || defaultEmailFieldText}
                executedFunction={value => { changeInputValue('email_text', value); }}
                validationErrors={value => { return linkTextValidation(value); }}
                actionErrors={patchAnonymousMessageError && patchAnonymousMessageError.email_text}
              />
            </div>
            <div className="cell">
              <Checkbox
                toggle
                name="email_is_required"
                checked={me.message_settings.email_is_required}
                onChange={checkboxChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DirectMesssageAppearence.propTypes = {
  id: PropTypes.number.isRequired,
  me: PropTypes.object,
  patchAnonymousMessageError: PropTypes.object,
  patchMessageSettings: PropTypes.func,
};
DirectMesssageAppearence.defaultProps = {
  me: null,
  patchAnonymousMessageError: null,
  patchMessageSettings: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchAnonymousMessageError: state.anonymousMessagesReducer.patchAnonymousMessageError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchMessageSettings,
  },
)(DirectMesssageAppearence);
